import {Injectable} from "@angular/core";
import {Action, Selector, State, StateContext} from "@ngxs/store";
import {tap} from "rxjs";
import {EventsService} from "../services/events.service";
import {EventDTO} from "../models/eventDTO.model";
import {GetEventsAction} from "./actualite.actions";
import {formatDate} from "@angular/common";

export interface ActualiteStateModel {
  events: EventDTO[],
}

@State<ActualiteStateModel>({
  name: "ActualitesStore",
  defaults: {
    events: [],
  },
})
@Injectable()
export class ActualiteState {
  constructor(private service: EventsService) {}

  @Selector()
  static selectPastEvents(state: ActualiteStateModel) {
    let time = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    let sortedEvents = state.events.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
    return sortedEvents.filter(e => e.date.toString() < time);
  }

  @Selector()
  static selectFutureEvents(state: ActualiteStateModel) {
    let time = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    let sortedEvents = state.events.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
    return sortedEvents.filter(e => e.date.toString() > time);
  }

  /**
   * State action to get events
   * @param ctx StateContext<HofState>
   * @returns all events
   */
  @Action(GetEventsAction)
  getEventsAction(ctx: StateContext<ActualiteStateModel>) {
    return this.service.getAllEvents().pipe(
      tap((res) => {
        const state = ctx.getState();
        ctx.setState({
          ...state,
          events: res,
        });
      })
    );
  }
}
